import React from 'react';
import { Box, Card, CardMedia, Typography } from '@mui/material';
import { mediaAPI } from '../../services/mediaAPI';

const MediaDisplay = ({ media, maxHeight = 400 }) => {
  if (!media || !media.url) return null;

  const fullUrl = mediaAPI.getFullUrl(media.url);

  return (
    <Card sx={{ mb: 2 }}>
      {media.type === 'image' && (
        <CardMedia
          component="img"
          image={fullUrl}
          alt="Question média"
          sx={{ 
            maxHeight: maxHeight,
            objectFit: 'contain',
            bgcolor: 'grey.100'
          }}
        />
      )}

      {media.type === 'audio' && (
        <Box sx={{ p: 2, bgcolor: 'grey.50' }}>
          <audio 
            controls 
            style={{ width: '100%' }}
            src={fullUrl}
          >
            Votre navigateur ne supporte pas l'élément audio.
          </audio>
        </Box>
      )}

      {media.type === 'video' && (
        <Box sx={{ bgcolor: 'grey.900' }}>
          <video 
            controls 
            style={{ 
              width: '100%', 
              maxHeight: maxHeight,
              display: 'block'
            }}
            src={fullUrl}
          >
            Votre navigateur ne supporte pas l'élément vidéo.
          </video>
        </Box>
      )}
    </Card>
  );
};

export default MediaDisplay;

